import React from 'react';
import Styles from './WhiteButton.css';

function WhiteButton({ wide, isButton, ...props }) {
  return (
    <>
      {isButton ? (
        <button
          href=""
          {...props}
          className={`shr-btn-white ${props.className} ${wide ? 'wide' : ''}`}
        />
      ) : (
        <a
          href=""
          {...props}
          className={`shr-btn-white ${props.className} ${wide ? 'wide' : ''}`}
        />
      )}

      <style jsx>{Styles}</style>
    </>
  );
}

export default WhiteButton;
